import { AccountReportEncryptionChartEntity } from '../entities/';
import { authResource } from './Auth';
export const AccountReportEncryptionChartResource = authResource({
    path: '/accounts/:accountId/reports/encryptions/chart/:chartId?',
    searchParams: {},
    schema: AccountReportEncryptionChartEntity
});
